__turbopack_context__.v({
  "body": "notification-module__5K4BIG__body",
  "closeButton": "notification-module__5K4BIG__closeButton",
  "description": "notification-module__5K4BIG__description",
  "icon": "notification-module__5K4BIG__icon",
  "loader": "notification-module__5K4BIG__loader",
  "root": "notification-module__5K4BIG__root",
  "title": "notification-module__5K4BIG__title",
});
